import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { HashtagPerReport } from '../models/hashtagPerReport';
import { HashtagService } from '../services/hashtag.service';
import { EventBusService } from '../../../../services/event-bus.service';

/**
 * Hashtag overview component
 */
@Component({
  selector: 'hashtags-overview',
  templateUrl: './hashtags-overview.component.html',
  styleUrls: ['./hashtags-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class HashtagsOverviewComponent implements OnInit, OnDestroy {
  /**
   * List of all empty hashtags for report
   */
  private emptyHashTags: HashtagPerReport[] = [];

  /**
   * List of all  hashtags with value 1 for report
   */
  private hashTagsWithValue1: HashtagPerReport[] = [];

  /**
   * The (list of) subscription(s)
   */
  subscriptions: Subscription = new Subscription();

  /**
   * Collapse empty section?
   */
  collapseEmptySection = false;

  /**
   * Collapse section with value of 1?
   */
  collapseSectionWithValues1 = false;

  /**
   * Constructor
   * @param hashtagService HashtagService
   * @param ref ChangeDetectorRef
   * @param translate TranslateService
   * @param eventBus EventBusService
   */
  constructor(private hashtagService: HashtagService,
    private ref: ChangeDetectorRef,
    private translate: TranslateService,
    private eventBus: EventBusService) { }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.subscriptions.add(this.hashtagService.allSelectedHashTags$.subscribe(data => {
      if (data) {
        this.emptyHashTags = data.filter(ht => !ht.value || ht.value == "0");
        this.hashTagsWithValue1 = data.filter(ht => ht.value == "1");
        this.ref.markForCheck();
      }
    }));
    //refresh hashtags
    this.hashtagService.getHashTagsForReport();
  }

  /**
   * Get hashtag name by key using translate service
   */
  getHashTagName(key: string): string {
    const translationKey = `hashTags.${key}`;
    return this.translate.instant(translationKey);
  }

  /**
   * Broadcast event to activate page where widget is displayed, when hashtag is clicked
   */
  onHashtagClicked(pageNum: number) {
    setTimeout(() => {
      this.eventBus.broadcastEvent("activatePage", pageNum - 1);
    }, 50);
  }

  /**
   * Destroys the component
   */
  ngOnDestroy(): void {
    if (this.subscriptions.unsubscribe) {
      this.subscriptions.unsubscribe();
    }
  }
}
